import { takeLatest, call, put } from 'redux-saga/effects'
import * as fromActions from '../../../actions/questions.action'

async function get() {
  // return await getQuestionList(instanceId);
}

function* questionGetEffectSaga() {
  try {
    const data = yield call(get)
    yield put(fromActions.Actions.questionGetSuccess(data))
  } catch (error) {
    console.log('error: ', error)
  }
}

export function* questionGetWatcherSaga() {
  yield takeLatest(fromActions.GET_QUESTIONS_LIST, questionGetEffectSaga)
}
